import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { businessData } from '../data/businessData';
import { Service } from '../types';

interface ServicesProps {
  onServiceSelect: (service: Service) => void;
}

const ServicesSection: React.FC<ServicesProps> = ({ onServiceSelect }) => {
  return (
    <section id="services" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Our Services</h2>
          <p className="lead text-muted mb-4">
            Comprehensive automobile repair and maintenance services for all car brands
          </p>
        </div>

        <Row>
          {businessData.services.map((service) => (
            <Col lg={4} md={6} className="mb-4" key={service.id}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body className="d-flex flex-column">
                  <h5 className="card-title mb-3">{service.service_name}</h5>
                  <div className="text-success fw-bold mb-3">
                    ₹{service.starting_price}+ {service.unit}
                  </div>
                  <p className="card-text text-muted flex-grow-1">
                    {service.description}
                  </p>
                  <Button 
                    variant="primary" 
                    className="w-100 fw-semibold mt-auto"
                    onClick={() => onServiceSelect(service)}
                  >
                    Book This Service
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;